export default __webpack_public_path__ + "static/media/t.289f7fc4.svg";